/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { LOGOUT } from 'store/authReducer';
import { store } from 'store';

import { getLoginWithReturnUrl } from 'utils/Login';

const axiosServices = axios.create();
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    axiosServices.defaults.baseURL = 'https://localhost:5000';
}
else {
    axiosServices.defaults.baseURL = 'https://interakcieliekov.sk/api/';
}

//validate response
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            try {
                localStorage.removeItem('slekuser');
                delete axios.defaults.headers.common.Authorization;
                store.dispatch({ type: LOGOUT });
                window.location.href = getLoginWithReturnUrl();
            }
            catch(err) {
                return Promise.reject(error);
            }
        }
        console.error(error);
        return Promise.reject((error.response && error.response.data) || { message: 'Volanie vzdialeného servera zlyhalo' });
    }
);

export default axiosServices;
